export enum AlertType {
    ExpiredKycLevel2Request = 'expiredKycLevel2Request',
    ExpiringKycLevel2Request = 'expiringKycLevel2Request',
    NotValidatedTokenHolder = 'notValidatedTokenHolder',
    UnfilledAmlQuestionnaire = 'unfilledAmlQuestionnaire',
}

export const ALERT = {
    [AlertType.ExpiringKycLevel2Request]: {
        description: 'kycLevel2Notification.expiring.description',
        hideCloseIcon: false,
        mobileIconCharCode: '0xe9bd',
        title: 'kycLevel2Notification.expiring.title',
        type: 'warning',
        webIcon: 'calendar-alert',
    },
    [AlertType.ExpiredKycLevel2Request]: {
        description: 'kycLevel2Notification.expired.description',
        hideCloseIcon: false,
        mobileIconCharCode: '0xe9bd',
        title: 'kycLevel2Notification.expired.title',
        type: 'error',
        webIcon: 'calendar-alert',
    },
    [AlertType.NotValidatedTokenHolder]: {
        description: 'kycUserIdentity.kycLevel2Features',
        hideCloseIcon: false,
        mobileIconCharCode: '0xe920',
        title: 'kycUserIdentity.verifyYourIdentity',
        type: 'warning',
        webIcon: 'identity',
    },
    [AlertType.UnfilledAmlQuestionnaire]: {
        description: 'userAMLQuestionnaire.notification.description',
        hideCloseIcon: true,
        mobileIconCharCode: '0xe9bf',
        title: 'userAMLQuestionnaire.notification.title',
        type: 'warning',
        webIcon: 'questionnaire',
    },
};